import PermitNumbers from './PermitNumbers';

export default PermitNumbers;
